export enum PayTypeEnum {
  wx_pub_qr = "wx_pub_qr",
  alipay_qr = "alipay_qr",
  wx_wap = "wx_wap",
  alipay = "alipay",
  alipay_wap = "alipay_wap",
  paypal = "paypal",
  alipay_qr_intl = 'alipay_qr_intl',
  alipay_wap_intl = 'alipay_wap_intl',
  union = 'union',
  wx_native_qr = 'wx_native_qr',
  wx_native_wap = 'wx_native_wap'
}
